import script from "./process-chain-graph.vue?vue&type=script&setup=true&lang=ts"
export * from "./process-chain-graph.vue?vue&type=script&setup=true&lang=ts"

import "./process-chain-graph.vue?vue&type=style&index=0&id=2686a709&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2686a709"]])

export default __exports__